<div class="main-content" (window:resize)="onResize($event)">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="col-md-12">
                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <h1 class="h3 mb-0 text-gray-800">Profile <i [popover]="esr" class="fas fa-question-circle pointer"></i></h1>
                        <popover-content #esr
                                         title="Profile"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Profile</p>
                        </popover-content>

                        <div class="btns-container">
                            <a *ngIf="tabIndex == 0" (click)="saveCoach()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-save text-white-50"> <span class="button-text"> Save</span></i>
                            </a>

                            <a *ngIf="tabIndex == 1" (click)="updatePassword()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-save text-white-50"> <span class="button-text"> Change password</span></i>
                            </a>

                            <a *ngIf="tabIndex == 3" (click)="getUserPersonalData()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-shopping-cart text-white-50"> <span class="button-text"> Purchase</span></i>
                            </a>
                        </div>
                    </div>

                    <div>
                        <form id="shopifyForm" action="https://community.ipeccoaching.com/sso-eli-shopify/" method="post" enctype="multipart/form-data">
                            <input type="text" name="contact_id" value="" hidden>
                            <input type="email" name="user_email" value="" hidden>
                            <input type="text" name="first_name" value="" hidden>
                            <input type="text" name="last_name" value="" hidden>
                        </form>
                    </div>

                    <div class="topSpacing">

                        <div class="desktopTabs">
                            <ul class="tab-nav">
                                <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#profileTab1">Personal Info</a></li>
                                <li *ngIf="!userInfo.ELICertified" (click)="tabSelect(1)"><a data-toggle="tab" href="#profileTab2">Change Password</a></li>
                                <li *ngIf="userInfo.ELICertified" (click)="tabSelect(3)"><a data-toggle="tab" href="#profileTab4">Available Assessments</a></li>
                            </ul>
                        </div>

                        <div class="main-tab-content tab-content assessmentsComponent">
                            <div id="profileTab1" class="tab-pane fade in active">
                                <div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Email:</label>
                                        </div>

                                        <div class="col-md-10">
                                            <input #email
                                                   id="email"
                                                   placeholder="Email"
                                                   type="email"
                                                   disabled
                                                   (keypress)="preventSpace(email.value, $event, 'email')"
                                                   (keyup)="preventSpace(email.value, $event, 'email')"
                                                   [(ngModel)]="userInfo.email"
                                                   class="form-control" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>First name:</label>
                                        </div>

                                        <div class="col-md-10">
                                            <input #firstName
                                                   id="firstName"
                                                   placeholder="First name"
                                                   type="text"
                                                   (keypress)="_Globals.allowOnlyNumberAndLetters($event)"
                                                   [(ngModel)]="userInfo.firstName"
                                                   class="form-control" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Last name:</label>
                                        </div>

                                        <div class="col-md-10">
                                            <input #lastName
                                                   id="lastName"
                                                   placeholder="Last name"
                                                   type="text"
                                                   (keypress)="_Globals.allowOnlyNumberAndLetters($event)"
                                                   [(ngModel)]="userInfo.lastName"
                                                   class="form-control" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Business name:</label>
                                        </div>

                                        <div class="col-md-10">
                                            <input #business
                                                   id="business"
                                                   placeholder="Business name"
                                                   type="text"
                                                   (keypress)="preventSpace(business.value, $event, 'business')"
                                                   (keyup)="preventSpace(business.value, $event, 'business')"
                                                   [(ngModel)]="userInfo.business"
                                                   class="form-control" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                        </div>

                                        <div class="col-md-10">
                                            <div id="currentLogo">

                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>My logo:</label>
                                        </div>

                                        <div class="col-md-10">
                                            <image-upload [max]="1"
                                                          [preview]="true"
                                                          [extensions]="['jpeg','png']"
                                                          [buttonCaption]="'Select your logo'"
                                                          [dropBoxMessage]="'Drop your logo here'"
                                                          [clearButtonCaption]="'Remove'"
                                                          [class]="'customClass'"
                                                          (removed)="onRemoved($event)"
                                                          (uploadFinished)="onUploadFinished($event)"
                                                          (uploadStateChanged)="onUploadStateChanged($event)">
                                            </image-upload>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="profileTab2" class="tab-pane fade">
                                <div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Current password: </label>
                                        </div>
                                        <div class="col-md-10">
                                            <input class="form-control"
                                                   #_currentPassword
                                                   id="currentPassword"
                                                   type="password"
                                                   name="currentPassword"
                                                   placeholder="Current password"
                                                   autocomplete="new-password"
                                                   [(ngModel)]="userInfo.currentPassword"
                                                   (keyup)="preventSpace(_password1.value, $event, 'currentPassword')" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>New password: </label>
                                        </div>
                                        <div class="col-md-10">
                                            <input class="form-control"
                                                   #_password1
                                                   id="password1"
                                                   type="password"
                                                   name="password1"
                                                   placeholder="Password"
                                                   autocomplete="new-password"
                                                   [(ngModel)]="userInfo.password1"
                                                   (keyup)="preventSpace(_password1.value, $event, 'password1')"
                                                   (focusout)="confirmationFail()"
                                                   (focusin)="removeMessage()"
                                                   (input)="validForm()" />
                                            <app-password-strength [passwordToCheck]="_password1.value"
                                                                   (passwordStrength)="passwordValid($event)">
                                            </app-password-strength>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Confirm password: </label>
                                        </div>
                                        <div class="col-md-10">
                                            <input class="form-control pass2"
                                                   #_password2
                                                   id="password2"
                                                   type="password"
                                                   name="password2"
                                                   placeholder="Confirm password"
                                                   autocomplete="new-password"
                                                   [(ngModel)]="userInfo.password2"
                                                   (keyup)="preventSpace(_password2.value, $event, 'password2')"
                                                   (focusout)="confirmationFail()"
                                                   (focusin)="removeMessage()"
                                                   (input)="validForm()" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-offset-2 col-md-10">
                                            <span id="errorPasswordMessage"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="profileTab4" class="tab-pane fade">
                                <div class="row">
                                    <div class="col-sm-3 text-right leftOnResponsive" style="width: 150px;">
                                        <span class="bold middleAlign">Self Assessments: </span>
                                    </div>
                                    <div class="col-sm-9 input-col-sm-9">
                                        <span><b>{{selfAssessments.Amount}}</b></span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-3 text-right leftOnResponsive" style="width: 150px;">
                                        <span class="bold middleAlign">360 Assessments: </span>
                                    </div>
                                    <div class="col-sm-9 input-col-sm-9">
                                        <span><b>{{assessments360.Amount}}</b></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
            </div>
        </div>
    </div>
</div>

<!--PURCHASE MODAL-->
<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
